(function (scope) {
  'use strict';
  const failure = (code, diagnostic) => Object.assign(new Error(code), { code, diagnostic });
  async function fetchAll(options) {
    const origin = options.origin || scope.location?.origin || new URL(options.url).origin;
    const firstURL = new URL(options.url, origin);
    firstURL.searchParams.set('view', 'gml-finder-feed');
    firstURL.searchParams.set('page', '1');
    firstURL.searchParams.set('_gml_fresh', String(Date.now()));
    const request = options.fetch || scope.fetch.bind(scope);
    const items = [];
    const ids = new Set();
    const visited = new Set();
    let nextURL = firstURL;
    let page = 1;
    let total = null;
    let pages = null;
    let currency = null;
    let locale = null;
    while (nextURL) {
      if (nextURL.origin !== firstURL.origin || nextURL.pathname !== firstURL.pathname || visited.has(nextURL.href)) throw failure('inventory_changed');
      visited.add(nextURL.href);
      const response = await request(nextURL.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: options.signal });
      const diagnostic = { status: response.status, contentType: response.headers?.get('content-type'), page };
      if (!response.ok) throw failure('inventory_error', { ...diagnostic, stage: 'http' });
      let payload;
      try { payload = await response.json(); } catch (_) { throw failure('inventory_error', { ...diagnostic, stage: 'json' }); }
      if (payload.version !== 2 || !Array.isArray(payload.items) || !Number.isInteger(payload.total) || !Number.isInteger(payload.pages) || payload.total < 0 || payload.pages < 0 || payload.currentPage !== page) throw failure('inventory_error', { ...diagnostic, stage: 'schema' });
      if (options.currency && payload.currency !== options.currency) throw failure('currency_error');
      if (total === null) { total = payload.total; pages = payload.pages; currency = payload.currency; locale = payload.locale; }
      if (payload.total !== total || payload.pages !== pages || payload.currency !== currency || payload.locale !== locale || page > Math.max(1, pages)) throw failure('inventory_changed');
      for (const product of payload.items) {
        if (!product.id || ids.has(String(product.id))) throw failure('inventory_changed');
        ids.add(String(product.id));
        items.push({ ...product, currency: payload.currency });
      }
      if (options.onPage) options.onPage({ page, pages, count: items.length, total });
      if (payload.nextURL) {
        if (page >= pages) throw failure('inventory_changed');
        const candidate = new URL(payload.nextURL, firstURL);
        firstURL.searchParams.forEach((value, key) => { if (key !== 'page') candidate.searchParams.set(key, value); });
        if (Number(candidate.searchParams.get('page')) !== page + 1) throw failure('inventory_changed');
        nextURL = candidate;
      } else {
        if (page !== Math.max(1, pages)) throw failure('inventory_changed');
        nextURL = null;
      }
      page += 1;
    }
    if (items.length !== total) throw failure('inventory_changed');
    return { items, currency, total, pages, locale };
  }
  async function fetchLocalized(options) {
    const localizedURL = new URL(options.url);
    const sourceURL = options.sourceURL ? new URL(options.sourceURL) : localizedURL;
    if (sourceURL.pathname === localizedURL.pathname) return fetchAll(options);
    if (sourceURL.origin !== localizedURL.origin) throw failure('inventory_error');
    const [localized, source] = await Promise.all([fetchAll(options), fetchAll({ ...options, url: sourceURL.href })]);
    if (source.locale !== 'en') throw failure('inventory_error');
    if (localized.total !== source.total || localized.currency !== source.currency) throw failure('inventory_changed');
    const originals = new Map(source.items.map(product => [String(product.id), product]));
    const items = localized.items.map(product => {
      const original = originals.get(String(product.id));
      if (!original || original.priceCents !== product.priceCents || original.available !== product.available) throw failure('inventory_changed');
      return { ...product, source: original };
    });
    return { ...localized, items };
  }
  const api = Object.freeze({ fetchAll, fetchLocalized });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  scope.GmlFinderFeed = api;
})(typeof window !== 'undefined' ? window : globalThis);
